const locales = [{ locale: "en" }, { locale: "vi" }, { locale: "cs" }]

const defaultLocale = "vi"

export { defaultLocale, locales }
